import { useQueryClient } from "@tanstack/react-query";

import { caseTemplatesKeys } from "src/cases/queries/templates";
import { DashboardPageParams } from "src/router/urls";
import { useCopilotRefetchOnMutation } from "src/unifiedCopilot/context/hooks";
import { useParamsDecode } from "src/utils/useParamsDecode";

/**
 * Refetches case template data after a copilot tool call mutated backend state.
 * The copilot window is mounted app-wide, so a tool call can change a version
 * while a template surface is on screen. The whole subtree is invalidated
 * because one tool call can change the list, a template's versions and the
 * schemas at once.
 */
export const useCaseTemplatesCopilotRefetch = (): void => {
  const { wsId } = useParamsDecode<DashboardPageParams>();
  const queryClient = useQueryClient();

  useCopilotRefetchOnMutation(() =>
    queryClient.invalidateQueries({ queryKey: caseTemplatesKeys.all(wsId) }),
  );
};
